import { CallbackComponent } from 'redux-oidc';
import commonResources from '@/common/resources/common';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { User } from 'oidc-client';
import userManager from '../../oidc/userManager';

type OidcCallbackProps = RouteComponentProps<any>;

/**
 * OidcCallback Component
 */
class OidcCallback extends React.Component<OidcCallbackProps> {
  successCallback = (user: User) => {
    const { history } = this.props;
    // get the user's previous location, passed during signinRedirect()
    const redirectPath = user.state.path;
    history.push(redirectPath);
  };

  errorCallback = (error: Error) => {
    const { history } = this.props;
    history.push('/');
  };

  render() {
    return (
      <CallbackComponent
        userManager={userManager}
        successCallback={this.successCallback}
        errorCallback={this.errorCallback}
      >
        <div>
          {' '}
          <FormattedMessage id={commonResources.yonlendiriliyor.id} />
        </div>
      </CallbackComponent>
    );
  }
}

export default connect()(OidcCallback);
